// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WyjXx","questions":"styles_questions__2gC0J","footer":"styles_footer__3HSc1"};